import { SafeLocalStorage } from './localStorage';

export const LEADER_REDIRECT_URL = 'LEADER_REDIRECT_URL';

export const setLeaderRedirectUrl = (toRedirectUrl: string): void => {
  // We can do this better.
  if (toRedirectUrl &&
    /https:\/\/(app\.|(\w+)?-(\w+)?-(\w+)?(-\w+)?\.)cribl(-gov)?(-staging)?\.cloud/.test(toRedirectUrl)) {
    SafeLocalStorage.setItem(LEADER_REDIRECT_URL, toRedirectUrl);
  }
};

export const setLeaderRedirectUrlFromQuery = (): void => {
  const queryString = window.location.search;
  const toRedirectUrl = new URLSearchParams(queryString).get('from');
  setLeaderRedirectUrl(toRedirectUrl as string);
};

export const getCleanLeaderRedirectUrl = (): string | null => {
  const toRedirectUrl = SafeLocalStorage.getItem(LEADER_REDIRECT_URL);
  SafeLocalStorage.removeItem(LEADER_REDIRECT_URL);

  return toRedirectUrl;
};
